module.exports = __webpack_public_path__ + "static/media/ui_ux_design-01.a3c44d84.txt";